import { defineMessages } from 'react-intl';

import { connect } from 'react-redux';

import WarningIcon from '@/tabler-icons/alert-triangle.svg?react';
import { injectIntl } from '@/mastodon/components/intl';
import { IconButton } from 'mastodon/components/icon_button';

import { changeComposeSpoilerness } from '../../../actions/compose';

const messages = defineMessages({
  marked: { id: 'compose_form.spoiler.marked', defaultMessage: 'Text is hidden behind warning' },
  unmarked: { id: 'compose_form.spoiler.unmarked', defaultMessage: 'Text is not hidden' },
});

const mapStateToProps = (state, { intl }) => ({
  icon: 'warning',
  iconComponent: WarningIcon,
  title: intl.formatMessage(state.getIn(['compose', 'spoiler']) ? messages.marked : messages.unmarked),
  active: state.getIn(['compose', 'spoiler']),
  ariaControls: 'cw-spoiler-input',
  size: 18,
  inverted: true,
});

const mapDispatchToProps = dispatch => ({

  onClick () {
    dispatch(changeComposeSpoilerness());
  },

});

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(IconButton));
